import {FormBase} from '../../components/formsBase/formBase';

/**
 * React functional component representing the Respiratory Symptoms Base.
 * @component
 * @param {Object} props - The properties of the component.
 * @param {ReactNode} props.children - The child components.
 * @returns {JSX.Element} The rendered RespiratorySymptomsBase component.
 */
export const RespiratorySymptomsBase = ({children, ...props}) => (
  <FormBase {...props} pageNames={['Start', 'Cough', 'Done']}>
    {children}
  </FormBase>
);
